import script from "./TeamTaxes.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamTaxes.vue?vue&type=script&setup=true&lang=js"

import "./TeamTaxes.vue?vue&type=style&index=0&id=55c0be42&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c0be42"]])

export default __exports__